import { render, staticRenderFns } from "./commerce-items.vue?vue&type=template&id=7ed23e0e"
import script from "./commerce-items.vue?vue&type=script&lang=js"
export * from "./commerce-items.vue?vue&type=script&lang=js"
import style0 from "./commerce-items.vue?vue&type=style&index=0&id=7ed23e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports